import * as React from 'react';
import { CalendarViewMode } from '../redux-state/interfaces/calendar-settings';
import { CalendarEventToggleProps, CalendarEventToggleViewProps } from './calendar-event-toggle ';


const CalendarEventToggleView: React.StatelessComponent<CalendarEventToggleViewProps> = props => {


    function onChange(value: string) {
        var updatedFilters = props.currentFilters.set("eventType", value);

        var name = "";
        if (updatedFilters.get('name')) {
            name = updatedFilters.get('name');
        }

        var location = "";
        if (updatedFilters.get('location')) {
            location = updatedFilters.get('location');
        }

        var category = "";
        if (updatedFilters.get('categories')) {
            category = updatedFilters.get('categories');
        }

        let filters = {};

        updatedFilters.forEach(function (value, key) {
            filters[key] = value
        });

        props.getFirstOccurenceDateForFilters(filters, props.lastMonthToLoad, props.lastLoadedMonth);
        props.selectFilterType(value);
    }
    function getEventValue(index: number, value: string): string {
        if (index != 0)
            return value;
        return "";
    }

    function disableEventButton(index: number, selectedEventType: string, value: string): boolean {
        if (index == 0 && (!selectedEventType || selectedEventType === ""))
            return true;
        if (selectedEventType === value)
            return true;
        return false;
    }
    return (
        <div className="block-inner ace-cal-event-nav">
            <div className="ace-cal-toggles ace-cal-subnav-item">
                {
                    props.options.length > 0 ?
                        props.options.map((li, index) => <button className="btn-pill-checkmark ace-cal-filters-pill" type="button" disabled={disableEventButton(index, props.selectedEventType, li.value)} onClick={() => props.selectFilterType(getEventValue(index, li.value))}>{li.text}</button>)
                        : null
                }

            </div>
        </div>
    );
}

export default CalendarEventToggleView;